import { useSelector } from 'react-redux';

const useFeatureFlags = () => {
    const user = useSelector((state) => state.CommonReducer.user);

    const isFeatureEnabled = (flag) => {
        return user && user.featureFlags.includes(flag)
    };

    return {
        isFeatureEnabled
    };
};

export default useFeatureFlags;
